var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { ManagedRemoteConfigProvider, RemoteConfigProvider, } from '@spotify-internal/remote-config-integration-react';
import { ClientResolver } from './resolver-client';
const isServer = typeof window === 'undefined';
export function NextJsRemoteConfigProvider(_a) {
    var { resolver = ClientResolver } = _a, props = __rest(_a, ["resolver"]);
    const initialConfiguration = props.options.initialConfiguration;
    return isServer ? (React.createElement(RemoteConfigProvider, { configuration: initialConfiguration || null }, props.children)) : (React.createElement(ManagedRemoteConfigProvider, Object.assign({ initialConfiguration: initialConfiguration, resolver: resolver }, props)));
}
//# sourceMappingURL=provider.js.map